export default __webpack_public_path__ + "static/media/hht2_ep2_speaking_04.3c99ebd2.png";